import { gql } from 'apollo-angular'

export const REMOVE_DOMAINNAME = gql`
  mutation RemoveDomainName($domainId: Int!) {
    deleteOrganizationDomain(id: $domainId) {
      id
    }
  }
`
